module.exports = __webpack_public_path__ + "static/media/tire.9bb8df40.svg";